import { type WorktypeAnalysisRating } from '@/features/types';
import { getMantineTheme } from '@/assets/styles/themeMantine';
import { hexToRgba } from '@/helpers/colors';

export interface ColourMap {
  [key: string]: number[];
}

const { workTypeColor } = getMantineTheme().other;

const rgb = (hex: string) => {
  const { r, g, b } = hexToRgba(hex);
  return [r, g, b];
};

export const WTA_COLOR_MAP: ColourMap = {
  '0': rgb(workTypeColor.noWorkType),
  '1': rgb(workTypeColor.noWorkType),
  '2': rgb(workTypeColor.herbicide),
  '3': rgb(workTypeColor.mow),
  '4': rgb(workTypeColor.cut),
  '5': rgb(workTypeColor.sideWall),
};

export const findKeyByNumArrayValue = (
  map: ColourMap,
  value: number[]
): string | undefined => {
  const entries = Object.entries(map);
  const matchingEntry = entries.find(([_, val]) => {
    return (
      val.length === value.length && val.every((num, i) => value[i] === num)
    );
  });
  return matchingEntry?.[0];
};

export const getWorktypeFromPixelColor = (
  worktypeColourMapping: ColourMap,
  pixelColorRGBA: number[]
): WorktypeAnalysisRating | undefined => {
  // number array is RGBA, convert to RGB
  if (pixelColorRGBA.length !== 4) {
    return undefined;
  }
  const rgb = pixelColorRGBA.slice(0, 3);
  const worktypeRatingNumString = findKeyByNumArrayValue(
    worktypeColourMapping,
    rgb
  );
  return worktypeRatingNumString ? Number(worktypeRatingNumString) : undefined;
};
